<template>
  <button type="button" :disabled="disabled" class="btn btn-primary" @click="$emit('click')">
    <slot>
      {{ label }}
    </slot>
  </button>
</template>

<script>
import { inject } from 'vue'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: function() { return inject('i18n').t('administrative.save') }
    }
  },

  emits: ['click']
}

</script>
